export default __webpack_public_path__ + "static/media/LolChampionGalleryImg_1.1dfe2c1e.png";